// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 59056, offsets 200049:200524. Structure and names inferred from code, not screenshots.

import * as DocumentNavigationModule from "./documentNavigation.js";
function getDocumentTitle(e, t, i) {
  let o = (function e(t, i) {
    for (let n of i) {
      if ("key" in n && n.key === t) return n;
      if ("items" in n && n.items) {
        let i = e(t, n.items);
        if (i) return i;
      }
    }
    return null;
  })(e, DocumentNavigationModule.jj);
  if (o && "titleZh" in o)
    return "zh" === (i || ("zh" === t("common.language") ? "zh" : "en"))
      ? o.titleZh
      : o.titleEn;
  if (e.includes(".")) {
    let i = t(e);
    if (i !== e) return i;
  }
  return e;
}
function getLocalizedTitle(e, t) {
  return "zh" === t ? e.titleZh : e.titleEn;
}
export { getDocumentTitle, getLocalizedTitle };
